/**
 * True when the app is running inside the packaged Capacitor native shell
 * (the installed iOS / Android app), false on the regular web client and
 * during SSR.
 *
 * Only the Capacitor build injects `window.Capacitor.isNativePlatform()`; on
 * the web it's undefined, so this returns false. Use it to hide install CTAs
 * (there's nothing to install once you're already in the app) and any other
 * web-only affordances.
 */
export function isNativePlatform(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }
  return !!(
    window as unknown as { Capacitor?: { isNativePlatform?: () => boolean } }
  ).Capacitor?.isNativePlatform?.();
}
